import { createApi } from "@reduxjs/toolkit/query/react";

export const rootApi = createApi({
  reducerPath: "rootApi",
  baseQuery: () => ({ data: null }),
  tagTypes: [
    "EmployeeInfo",
    "CompOffInfo",
    "PettyCashExpenseInfo",
    "ReimbursementInfo",
    "TeamMembersInfo",
    "EmployeeLeaveInfo",
    "RequisitionInfo",
    "JobOpeningsInfo",
    "CandidatesInfo",
    "ApplicationsInfo",
    "InterviewRoundTypesInfo",
    "InterviewsInfo",
    "OfferLettersInfo",
    "HrmReportsInfo",
    "TeamMembersLeaves",
    "EmployeeSalaryReportList"
  ],
  endpoints: () => ({}), // no endpoints directly here
});
